import type { TripSummary } from "../trips/tripStore";

export function localDateKey(date = new Date()): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function dateDistance(from: string, to: string): number {
  const stamp=(key:string)=>{const [y,m,d]=key.split("-").map(Number);return Date.UTC(y,m-1,d);};
  return Math.round((stamp(to)-stamp(from))/86400000);
}

export function homeTripModel(trips: TripSummary[], today = localDateKey()) {
  const visible = trips.filter((trip) => !trip.archivedAt && !trip.deletedAt);
  const groups = groupTripsByDeparture(trips,today);
  const active = groups.active;
  const upcoming = groups.upcoming;
  const completed = groups.completed;
  const recent = [...visible].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
  const featured = [...active].sort((a, b) => b.startDate.localeCompare(a.startDate))[0] || upcoming[0] || recent.find((trip) => !completed.includes(trip)) || [...completed].sort((a, b) => (b.endDate || b.updatedAt).localeCompare(a.endDate || a.updatedAt))[0];
  const featuredKind = featured && active.includes(featured) ? "active" : featured && upcoming.includes(featured) ? "upcoming" : featured && completed.includes(featured) ? "completed" : "planning";
  return { visible, active, upcoming, completed, recent, featured, featuredKind,
    destinations: new Set(completed.map((trip) => trip.destination.trim().toLocaleLowerCase()).filter(Boolean)).size };
}

export function groupTripsByDeparture(trips: TripSummary[], today = localDateKey()) {
  const groups: Record<"active"|"upcoming"|"completed"|"archived",TripSummary[]>={active:[],upcoming:[],completed:[],archived:[]};
  for (const trip of trips) {
    if (trip.deletedAt) continue;
    if (trip.archivedAt) { groups.archived.push(trip); continue; }
    if (trip.status === "completed" || (trip.endDate && trip.endDate < today)) groups.completed.push(trip);
    else if (trip.startDate && trip.startDate > today) groups.upcoming.push(trip);
    else if (trip.startDate && trip.startDate <= today) groups.active.push(trip);
    else if (trip.status === "active") groups.active.push(trip);
    else groups.upcoming.push(trip);
  }
  const compare=(a:TripSummary,b:TripSummary,direction:number)=>{
    if(!a.startDate&&b.startDate)return 1;if(a.startDate&&!b.startDate)return -1;
    return direction*a.startDate.localeCompare(b.startDate)||a.name.localeCompare(b.name)||a.id.localeCompare(b.id);
  };
  groups.active.sort((a,b)=>compare(a,b,1));groups.upcoming.sort((a,b)=>compare(a,b,1));groups.completed.sort((a,b)=>compare(a,b,-1));groups.archived.sort((a,b)=>compare(a,b,-1));
  return groups;
}
